import React, { useEffect, useState } from "react";
import Sidebar from "../../../component/home/sidebar";
import SearchForm from "../../../component/search-form";
import Table, { TableRow } from "../../../component/table";

import AddModal from "./modal";

import ViewModal from "./viewmodal";
import EditModal from "./editmodal";

import Loader from "react-spinner-loader";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";
import { useDispatch, useSelector } from "react-redux";
import {
  createDepartment,
  deleteDepartment,
  getDepartment,
  updateDepartment,
} from "../../../redux/actions/department";
import { useLocation } from "react-router-dom";
import BackButtonWindow from "../../../component/Alert/BackButtonWindow";
import useDebounce from "../../../Hook/useDebounce";

import { GETDEPARTMENT, GETDEPARTMENTDETAIL } from "../../../redux/constants";
import { sanitizeInput } from "../../../utils";
import PageSelector from "../../../component/PageSelector";
import RowsPerPageSelector from "../../../component/RowsPerPageSelector";

export default function Departments() {
  const [page, setPage] = useState(1);
  const [showmodal, setShowModal] = useState(false);
  const [viewmodal, setViewModal] = useState(false);
  const [editmodal, setEditModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [newloader, setNewLoader] = useState(false);
  const [sort, setSort] = useState();
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [searchText, setSearchText] = useState();

  // Use the debounce hook to get the debounced version of the handleSearch function
  const debouncedHandleSearch = useDebounce(searchText, 300);

  const { departmentList, departmentDetail } = useSelector(
    (state) => state.department
  );
  const { tempPageName, path } = useSelector((state) => state.tempWindowsData);
  const { row_count } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (path !== "" && tempPageName !== "") {
      setShowModal(true);
    }
  }, [path, tempPageName]);

  useEffect(() => {
    getTeamsData();
  }, [debouncedHandleSearch, page, row_count, sortField, sortOrder]);

  const getTeamsData = () => {
    setLoader(true);
    dispatch(
      getDepartment(
        (res) => {
          setLoader(false);
        },
        debouncedHandleSearch,
        page,
        row_count,
        sortField,
        sortOrder
      )
    );
  };

  const _handleSubmit = async (data) => {
    setNewLoader(true);
    dispatch(
      createDepartment(data, (res) => {
        setShowModal(false);
        dispatch(
          getDepartment((response) => {
            setNewLoader(false);
            if (res.status === 1) {
              swal({
                content: (
                  <CustomeModal
                    type="success"
                    title="Success!"
                    content="Team is added successfully."
                  />
                ),
                buttons: false,
                closeOnClickOutside: false,
                closeOnEsc: false,
              });
            } else if (res.status === 0) {
              swal({
                content: (
                  <CustomeModal
                    type="error"
                    title="Error!"
                    content={res.message}
                  />
                ),
                buttons: false,
                closeOnClickOutside: false,
                closeOnEsc: false,
              });
            }
          })
        );
      })
    );
  };

  const handleEditModal = async (updateuser) => {
    setNewLoader(true);
    dispatch(
      updateDepartment(departmentDetail.id, updateuser, (res) => {
        setEditModal(false);
        dispatch(
          getDepartment((response) => {
            setNewLoader(false);
            if (res.status === 1) {
              swal({
                content: (
                  <CustomeModal
                    type="success"
                    title="Success!"
                    content="Team is updated successfully."
                  />
                ),
                buttons: false,
                closeOnClickOutside: false,
                closeOnEsc: false,
              });
            }
          })
        );
      })
    );
  };

  const handleDeleteModal = async (id) => {
    dispatch(
      deleteDepartment(id, (res) => {
        getTeamsData();
      })
    );
  };

  /*--------- Sorting Booking ------------ */
  useEffect(() => {
    if (sort) {
      setPage(1);
      setSortField(sort.headName);
      setSortOrder(sort.type);
    }
  }, [sort]);

  const TeamTable = ({ index, name, time_zone, teamItem }) => {
    return (
      <TableRow
        key={index}
        row={{ name, time_zone }}
        tdClass="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-center first:text-left bg-[--bg-color-50] rounded-l-md max-w-1/4 truncate"
      >
        <td className="px-2 py-2 whitespace-nowrap text-center text-sm bg-[--bg-color-50] rounded-r-md leading-4 tracking-tight text-[--bg-color-500] font-semibold">
          <div className="space-x-3 flex items-center justify-center">
            <div title="Edit">
              <span
                className="fa-light fa-pen text-base cursor-pointer"
                style={{ color: "#9297a2" }}
                onClick={() => {
                  dispatch({
                    type: GETDEPARTMENTDETAIL,
                    payload: teamItem,
                  });
                  setEditModal(true);
                }}
              ></span>
            </div>
            <div title="Delete">
              <span
                className="fa-light fa-trash-can text-base cursor-pointer"
                style={{ color: "#eb5757" }}
                onClick={() => {
                  swal({
                    content: (
                      <CustomeModal
                        type="delete"
                        title="Are you sure?"
                        content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
                        onDelete={() => handleDeleteModal(teamItem.id)}
                      />
                    ),
                    buttons: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                  });
                }}
              ></span>
            </div>
          </div>
        </td>
      </TableRow>
    );
  };
  return (
    <>
      {path !== "" && tempPageName !== "" && (
        <BackButtonWindow
          backButtonName={tempPageName}
          title="Completed creating teams?"
          path={path}
        />
      )}
      <div className="mt-4 sm:mx-6 lg:mx-8">
        <div className="h-full flex flex-col md:flex-row min-h-screen">
          <Sidebar />
          <div className="flex-auto p-5 bg-white max-h-full w-full md:w-2/3">
            <div className="flex-auto space-y-2 md:space-y-0 md:flex md:justify-between md:item-center mb-2">
              <SearchForm
                placeholder="Search"
                onChange={(e) => {
                  const value = sanitizeInput(e.target.value);
                  setSearchText(value);
                }}
                value={searchText}
              />
              <div className="flex">
                <button
                  className="btn flex-auto ml-0 sm:ml-3 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
                  onClick={() => setShowModal(true)}
                >
                  <span className={`fas fa-plus mr-2`}></span>
                  New Team
                </button>
              </div>
            </div>
            <Table
              heads={[
                { headName: "Team Name", isSort: true, value: "name" },
                { headName: "Time Zone", isSort: true, value: "time_zone" },
                { headName: "Action", isSort: false, value: "Action" },
              ]}
              tClass="table-fixed w-full border-separate border-spacing-y-2"
              hClass="text-sm leading-2 tracking-tight font-semibold text-[#1E293B] bg-[--bg-color-100]"
              bClass="text-sm"
              thClass={`px-2 py-3 whitespace-nowrap first:text-left text-center font-semibold first:pl-4 first:rounded-l-md last:rounded-r-md max-w-1/4`}
              setSort={setSort}
              sort={sort}
            >
              {loader ? (
                <tr className="px-2 py-3 whitespace-nowrap">
                  <td colSpan={3}>
                    <div className="flex justify-center p-2 my-2 whitespace-nowrap w-full">
                      <Loader show={loader} />
                    </div>
                  </td>
                </tr>
              ) : departmentList?.data?.length > 0 ? (
                departmentList?.data.map((teamItem, index) => {
                  const { name, time_zone } = teamItem;
                  return (
                    <TeamTable
                      index={index}
                      name={name}
                      time_zone={time_zone}
                      teamItem={teamItem}
                    />
                  );
                })
              ) : (
                <td
                  colSpan={3}
                  className="text-center py-2 text-lg text-[#1E293B] tracking-tight leading-4"
                >
                  There are no records to display
                </td>
              )}
            </Table>
            {!loader && departmentList?.data?.length > 0 && (
              <div className="flex justify-between items-center">
                <RowsPerPageSelector />
                <PageSelector
                  rowPerPage={row_count}
                  page={page}
                  setpage={(newPage) => {
                    setPage(newPage);
                  }}
                  totalDataCount={
                    departmentList ? departmentList.totalCount : 0
                  }
                />
              </div>
            )}
          </div>
        </div>
        <AddModal
          id="add-modal"
          searchId="add"
          modalOpen={showmodal}
          setModalOpen={setShowModal}
          _handleSubmit={_handleSubmit}
        />

        <EditModal
          id={departmentDetail}
          searchId="edit"
          modalOpen={editmodal}
          setModalOpen={setEditModal}
          handleEditModal={handleEditModal}
        />
        <Loader modalOpen={newloader} />
      </div>
    </>
  );
}
Departments.auth = { path: "/departments", role: ["super-admin"] };
